var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowForwardCircleOutline = function SvgArrowForwardCircleOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    transform: "matrix(-1 0 0 1 42 6.39355)",
    stroke: "white",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 31.3936L32 24.3936L25 17.3936",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 25.3936C15.4477 25.3936 15 24.9458 15 24.3936C15 23.8413 15.4477 23.3936 16 23.3936V25.3936ZM16 23.3936H32V25.3936H16V23.3936Z",
    fill: "white"
  })));
};
export { SvgArrowForwardCircleOutline as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCA0OCA0OSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMTgiIGN5PSIxOCIgcj0iMTgiIHRyYW5zZm9ybT0ibWF0cml4KC0xIDAgMCAxIDQyIDYuMzkzNTUpIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTI1IDMxLjM5MzZMMzIgMjQuMzkzNkwyNSAxNy4zOTM2IiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8cGF0aCBkPSJNMTYgMjUuMzkzNkMxNS40NDc3IDI1LjM5MzYgMTUgMjQuOTQ1OCAxNSAyNC4zOTM2QzE1IDIzLjg0MTMgMTUuNDQ3NyAyMy4zOTM2IDE2IDIzLjM5MzZWMjUuMzkzNlpNMTYgMjMuMzkzNkgzMlYyNS4zOTM2SDE2VjIzLjM5MzZaIiBmaWxsPSJ3aGl0ZSIvPgo8L3N2Zz4K";